import React, { useState, useEffect, useRef } from 'react';
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';
import GetDistricts from '../../Dropdowns/getAllDistricts';
import GetAfsoo from "../../Dropdowns/getAfsoo";

import DistrictPortabilityReport from './DistrictPortabilityReport';
import BlockPortabilityReport from './BlockPortabilityReport';
import ShopPortabilityReport from './ShopPortabilityReport';
import axios from 'axios';

const PortabilityReport_Int = ({ heading }) => {
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [districtCode, setDistrictCode] = useState('');
    const [districtName, setDistrictName] = useState('');
    const [afsoCode, setAfsoCode] = useState('');
    const [afsoName, setAfsoName] = useState('');
    const [drilledDistrict, setDrilledDistrict] = useState('');
    const [drilledAfso, setDrilledAfso] = useState('');
    const [loading, setLoading] = useState(false);
    const [sessionLoaded, setSessionLoaded] = useState(false);

    // User session info
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userRole, setUserRole] = useState(null);
    const [userDistCode, setUserDistCode] = useState(null);

    const blockRef = useRef(null);
    const shopRef = useRef(null);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_URL}/api/ekyc-to-be-done/session-info`)
            .then(res => {
                console.log("SESSION INFO FULL RESPONSE:", res.data);

                const data = res.data;

                console.log("userRole:", data.userRole);
                console.log("distCode:", data.distCode);

                setUserRole(data.userRole ? String(data.userRole) : null);
                setUserDistCode(data.distCode ? String(data.distCode) : null);

                setIsLoggedIn(!!data.userRole);
                setSessionLoaded(true);
            })
            .catch(err => {
                console.error("SESSION ERROR", err);
                setIsLoggedIn(false);
                setSessionLoaded(true);
            });
    }, []);
    useEffect(() => {
        if (userRole === "2" && userDistCode) {
            setDistrictCode(userDistCode);

            fetch(`${process.env.REACT_APP_URL}/api/report/districts-list`)
                .then(res => res.json())
                .then(list => {
                    const found = list.find(d => d.dist_code === userDistCode);
                    if (found) {
                        setDistrictName(found.dist_name_en);
                        setDrilledDistrict(found.dist_name_en);
                    }
                });
        }
    }, [userRole, userDistCode]);


    useEffect(() => {
        if (String(userRole) === "2" || !districtCode) return;

        fetch(`${process.env.REACT_APP_URL}/api/report/districts-list`)
            .then(res => res.json())
            .then(list => {
                const found = list.find(
                    d => String(d.dist_code) === String(districtCode)
                );
                setDistrictName(found ? found.dist_name_en : '');
            })
            .catch(() => setDistrictName(''));
    }, [districtCode, userRole]);


    useEffect(() => {
        if (!districtName || !afsoCode) {
            setAfsoName('');
            return;
        }
        fetch(`${process.env.REACT_APP_URL}/api/report/blocks-list?district=${encodeURIComponent(districtName)}`)
            .then(res => res.json())
            .then(list => {
                const found = list.find(a => a.afso_code === afsoCode);
                setAfsoName(found ? found.afso_name_en : '');
            })
            .catch(() => setAfsoName(''));
    }, [districtName, afsoCode]);

    const handleDistrictChange = (code) => {
        if (userRole === "2") return;
        let finalCode = code || '';
        // Check for common "All" values: '0', 'All', or strictly containing "Select"
        if (finalCode === '0' || finalCode === 'All' || finalCode.toLowerCase().includes('select')) {
            finalCode = '';
        }
        setDistrictCode(finalCode);
        setAfsoCode('');
        setAfsoName('');
        setDrilledDistrict('');
        setDrilledAfso('');
        setMonth('');
        setYear('');
    };

    const handleAfsoChange = (code) => {
        let finalCode = code || '';
        if (finalCode === '0' || finalCode === 'All' || finalCode.toLowerCase().includes('select')) {
            finalCode = '';
        }
        setAfsoCode(finalCode);
        setDrilledAfso('');
    };


    const handleDistrictDrill = (districtName) => {
        setDrilledDistrict(districtName);
        //setDrilledAfso(''); 
    };

    const handleBlockDrill = (afsoName) => {
        setDrilledAfso(afsoName);
    };


    const handleSubmit = () => {
        const selectedMonth = document.getElementById('month')?.value;
        const selectedYear = document.getElementById('year')?.value;

        if (!selectedMonth || selectedMonth === '0') return alert('Please select Month');
        if (!selectedYear || selectedYear === '0') return alert('Please select Year');

        setMonth(selectedMonth);
        setYear(selectedYear);
        setDrilledDistrict('');
        setDrilledAfso('');
    };

    const isAllDistricts = !districtCode && userRole !== "2";
    const currentDistrict = districtName || drilledDistrict;
    const currentAfso = afsoName || drilledAfso;

    // const currentDistrict = drilledDistrict || districtName;
    // const currentAfso = drilledAfso;


    const showDistrictReport =
        month && year && !districtCode;

    const showBlockReport =
        month && year && (districtCode || drilledDistrict) && !afsoCode;

    const showShopReport =
        month && year && (districtCode || drilledDistrict) && (afsoCode || drilledAfso);


    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="60%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={8}>Portability Sale Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Month</td>
                                    <td><GetMonths onLoadingChange={setLoading} /></td>
                                    <td>Year</td>
                                    <td><GetYears onLoadingChange={setLoading} /></td>

                                    <td>District</td>
                                    <td>

                                        {String(userRole) !== "2" && (
                                            <GetDistricts
                                                onChange={handleDistrictChange}
                                                onLoadingChange={setLoading}
                                            />
                                        )}

                                        {String(userRole) === "2" && (
                                            <input
                                                type="text"
                                                value={districtName || 'Loading...'}
                                                readOnly
                                                style={{
                                                    border: '1px solid #ccc',
                                                    backgroundColor: '#f5f5f5',
                                                    padding: '4px',
                                                    width: '180px'
                                                }}
                                            />
                                        )}

                                    </td>

                                    <td>Block</td>
                                    <td>
                                        {districtCode ? (
                                            <GetAfsoo
                                                dist_code={districtCode}
                                                onChange={handleAfsoChange}
                                                onLoadingChange={setLoading}
                                            />
                                        ) : (
                                            <select disabled><option>Select District First</option></select>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={8} align="center">
                                        <button onClick={handleSubmit} className="button button2" disabled={loading}>
                                            Submit
                                        </button>
                                        <button className="button button2" onClick={() => window.history.back()}>
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <br />
                    {loading && (
                        <div style={{ textAlign: 'center' }}>
                            <img src="images/progress.gif" alt="Loading..." />
                            <p>Loading report...</p>
                        </div>
                    )}

                    <div id="details1">
                        {showDistrictReport && (
                            <DistrictPortabilityReport
                                month={month}
                                year={year}
                                heading="Portability Sale Details"
                                onDrillDown={handleDistrictDrill}
                            />
                        )}

                        {showBlockReport && (
                            <BlockPortabilityReport
                                month={month}
                                year={year}
                                district={currentDistrict}
                                heading="Portability Sale Details in "
                                onDrillDown={handleBlockDrill}
                            />
                        )}

                        {showShopReport && (
                            <ShopPortabilityReport
                                month={month}
                                year={year}
                                district={currentDistrict}
                                afso={currentAfso}
                                heading="Portability Sale Details in "

                            />
                        )}

                    </div>

                </div>
            </div>
        </>
    );
};

export default PortabilityReport_Int;